import type { BrandFontPreset } from "./font-presets.interface";

export const BRAND_FONT_PRESET_ID = "company";

export const CANVAS_DEFAULT_FONT_FAMILY =
  '"Open Sans", "Segoe UI", Helvetica, Arial, sans-serif';

const BRAND_SYSTEM_FONT_PRESETS: BrandFontPreset[] = [
  {
    id: "roboto",
    label: "Roboto",
    fontFamily: '"Roboto", Arial, sans-serif',
    fontCssUrl:
      "https://fonts.googleapis.com/css2?family=Roboto:wght@400;700&display=swap",
  },
  {
    id: "arial",
    label: "Arial",
    fontFamily: "Arimo, Arial, Helvetica, sans-serif",
    fontCssUrl:
      "https://fonts.googleapis.com/css2?family=Arimo:wght@400;700&display=swap",
  },
  {
    id: "verdana",
    label: "Verdana",
    fontFamily: '"Source Sans 3", Verdana, Geneva, sans-serif',
    fontCssUrl:
      "https://fonts.googleapis.com/css2?family=Source+Sans+3:wght@400;700&display=swap",
  },
  {
    id: "tahoma",
    label: "Tahoma",
    fontFamily: "Cabin, Tahoma, Geneva, sans-serif",
    fontCssUrl:
      "https://fonts.googleapis.com/css2?family=Cabin:wght@400;700&display=swap",
  },
  {
    id: "times",
    label: "Times New Roman",
    fontFamily: 'Tinos, "Times New Roman", Times, serif',
    fontCssUrl:
      "https://fonts.googleapis.com/css2?family=Tinos:wght@400;700&display=swap",
  },
  {
    id: "georgia",
    label: "Georgia",
    fontFamily: "Gelasio, Georgia, serif",
    fontCssUrl:
      "https://fonts.googleapis.com/css2?family=Gelasio:wght@400;700&display=swap",
  },
  {
    id: "courier",
    label: "Courier New",
    fontFamily: 'Cousine, "Courier New", Courier, monospace',
    fontCssUrl:
      "https://fonts.googleapis.com/css2?family=Cousine:wght@400;700&display=swap",
  },
];

export const BRAND_UI_FONT_PRESETS: BrandFontPreset[] = [
  { id: "default", label: "Default", fontFamily: "inherit" },
  ...BRAND_SYSTEM_FONT_PRESETS,
];

export const BRAND_CANVAS_FONT_PRESETS: BrandFontPreset[] = [
  {
    id: "default",
    label: "Default",
    fontFamily: CANVAS_DEFAULT_FONT_FAMILY,
    fontCssUrl:
      "https://fonts.googleapis.com/css2?family=Open+Sans:wght@400;700&display=swap",
  },
  ...BRAND_SYSTEM_FONT_PRESETS,
];
